export const fontSize = {
  xs: '12px',
};
